var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import gql from 'graphql-tag';
import { getDayMonthYear, getDayLongMonthYearWithSpace } from '@domain-group/fe-allhomes-library/lib/utils/format-date-time';
import { ListingViews } from './listing-views';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingViews on Property {\n    listing {\n      id\n      relistedDate\n      publicVisibleDate\n      pageViews\n      editDate\n    }\n  }\n"])));
var graphQLtoProps = _ref => {
  var listing = _ref.listing;
  return {
    listingId: listing.id,
    views: listing.pageViews,
    dateFirstVisible: getDayMonthYear(listing.publicVisibleDate),
    relistedDate: getDayMonthYear(listing.relistedDate),
    dateFirstVisibleDate: listing.publicVisibleDate,
    lastUpdated: getDayMonthYear(listing.editDate),
    lastUpdatedNew: getDayLongMonthYearWithSpace(listing.editDate)
  };
};
var ListingViewsGraphQL = _ref2 => {
  var property = _ref2.property,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(ListingViews, _extends({}, graphQLtoProps(property), otherProps));
};
ListingViewsGraphQL.fragment = fragment;
export { ListingViewsGraphQL };